module.exports = __webpack_public_path__ + "img/44-W3J.100000b.png";